import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

interface FormFilterInterface {
  employeeCode: string;
  month: number;
  status: string;
  year: number;
}

interface InitialState {
  filterInput: FormFilterInterface;
}

const initialState: InitialState = {
  filterInput: {
    employeeCode: "",
    month: moment().month() + 1,
    status: "",
    year: moment().year(),
  },
};

const formFilterTimeKeepingManagerSlice = createSlice({
  name: "formFilterTimeKeepingManager",
  initialState,
  reducers: {
    formFilterTimeKeepingManagerUpdate: (state, action) => {
      Object.assign(state.filterInput, action.payload);
    },

    formFilterTimeKeepingManagerReset: (state) => initialState,
  },
});

export const {
  formFilterTimeKeepingManagerUpdate,
  formFilterTimeKeepingManagerReset,
} = formFilterTimeKeepingManagerSlice.actions;

export default formFilterTimeKeepingManagerSlice.reducer;
